import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Home } from './components/Home'
import { SurveyLoader } from './components/SurveyLoader'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:surveyId" element={<SurveyLoader />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
